/**
 * Contains a disparity map
 * @class DisparityMap
 * @constructor
 * @param {number} width
 * @param {number} height
 * @param {DisparityTile} tile - the parent tile
 */
export class DisparityMap {
    constructor(width, height, image) {
        this.ready = false;
        this.image = null;
        this.disparityContext = null;
        this.imageDataDispValues = null;
        this.width = width;
        this.height = height;
        this.disparityCanvas = document.createElement("canvas");
        this.disparityContext = this.disparityCanvas.getContext("2d");
        this.disparityCanvas.width = width;
        this.disparityCanvas.height = height;
        this.disparityContext.drawImage(image, 0, 0);
        this.ready = true;
        this.image = image;
    }
    /**
     * Retrieve disparity value at given position
     * @method getDisparityValue
     * @param {number} tx pixel coordinate
     * @param {number} ty pixel coordinate
     * @param {boolean} cachedata
     * @return {number[]}
     */
    getDisparityValue(tx, ty, cachedata = true) {
        if (this.ready) {
            if (tx >= 0 && tx < this.width && ty >= 0 && ty < this.height) {
                if (this._dispArray != null) {
                    return this._dispArray[ty][tx];
                }
                //cache the data for a further request...
                if (cachedata)
                    this.getDisparityValueArray();
                const data = this.disparityContext.getImageData(tx, ty, 1, 1).data;
                const red = data[0];
                const green = data[1];
                const quality = data[2];
                return [red * 256 + green, quality];
            }
        }
        return [0, 0];
    }
    /**
     * Retrieve disparity value at given position
     * @method getDisparityValueArray
     */
    getDisparityValueArray() {
        if (this.ready) {
            const imgData = this.disparityContext.getImageData(0, 0, this.width, this.height);
            let d = 0;
            const dispArray = new Array(imgData.width);
            for (let k = 0; k < imgData.width; k++) {
                dispArray[k] = new Array(imgData.height);
            }
            const h = imgData.height;
            const w = imgData.width;
            const imgDataData = imgData.data;
            let adr = 0;
            let da;
            for (let i = 0; i < h; i++) {
                da = dispArray[i];
                for (let j = 0; j < w; j++) {
                    d = imgDataData[adr] << 8;
                    adr++;
                    d += imgDataData[adr];
                    adr++;
                    const q = imgDataData[adr];
                    adr = adr + 2;
                    da[j] = [d, q];
                }
            }
            this._dispArray = dispArray;
        }
    }
    destroy() {
        this.width = 0;
        this.height = 0;
        this.ready = false;
        this.disparityCanvas = null;
        this.image = null;
        this.disparityContext = null;
        this._dispArray = null;
        delete this._dispArray;
    }
}
//# sourceMappingURL=disparitymap.js.map